import { Routes, Route } from "react-router-dom"
import TutorialsAndDocumentation from "./pages/TutorialsAndDocumentation"
import TutorialPage from "./pages/TutorialPage"
// import NotFoundError from "../../components/NotFoundError"

export default function HelpCenter() {




    return (
        <Routes>
            <Route index element={<TutorialsAndDocumentation />} />
            <Route path=':title' element={<TutorialPage />} />
        </Routes>
    )
}